/**
 * Catalogue officiel des matières par diplôme et section.
 */

export interface SubjectCatalogEntry {
  diploma: 'BTS';
  section: string;
  subject: string;
  subject_code: string;
}

export const SUBJECTS_CATALOG: SubjectCatalogEntry[] = [
  // =====================
  // BTS MCO
  // =====================
  { diploma: 'BTS', section: 'MCO', subject: 'Culture générale et expression', subject_code: 'BTS_MCO_Culture_generale_et_expression' },
  { diploma: 'BTS', section: 'MCO', subject: 'Langue vivante étrangère', subject_code: 'BTS_MCO_Langue_vivante_etrangere' },
  { diploma: 'BTS', section: 'MCO', subject: 'Culture économique, juridique et managériale', subject_code: 'BTS_MCO_Culture_economique_juridique_manageriale' },
  { diploma: 'BTS', section: 'MCO', subject: 'Développement de la relation client et vente conseil', subject_code: 'BTS_MCO_Developpement_relation_client_vente_conseil' },
  { diploma: 'BTS', section: 'MCO', subject: 'Animation et dynamisation de l\'offre commerciale', subject_code: 'BTS_MCO_Animation_dynamisation_offre_commerciale' },
  { diploma: 'BTS', section: 'MCO', subject: 'Gestion opérationnelle', subject_code: 'BTS_MCO_Gestion_operationnelle' },
  { diploma: 'BTS', section: 'MCO', subject: 'Management de l\'équipe commerciale', subject_code: 'BTS_MCO_Management_equipe_commerciale' },

  // =====================
  // BTS NDRC
  // =====================
  { diploma: 'BTS', section: 'NDRC', subject: 'Culture générale et expression', subject_code: 'BTS_NDRC_Culture_generale_et_expression' },
  { diploma: 'BTS', section: 'NDRC', subject: 'Langue vivante étrangère', subject_code: 'BTS_NDRC_Langue_vivante_etrangere' },
  { diploma: 'BTS', section: 'NDRC', subject: 'Culture économique, juridique et managériale', subject_code: 'BTS_NDRC_Culture_economique_juridique_manageriale' },
  { diploma: 'BTS', section: 'NDRC', subject: 'Relation client et négociation-vente', subject_code: 'BTS_NDRC_Relation_client_negociation_vente' },
  { diploma: 'BTS', section: 'NDRC', subject: 'Relation client à distance et digitalisation', subject_code: 'BTS_NDRC_Relation_client_distance_digitalisation' },
  { diploma: 'BTS', section: 'NDRC', subject: 'Relation client et animation de réseaux', subject_code: 'BTS_NDRC_Relation_client_animation_reseaux' },

  // =====================
  // BTS CI
  // =====================
  { diploma: 'BTS', section: 'CI', subject: 'Culture générale et expression', subject_code: 'BTS_CI_Culture_generale_et_expression' },
  { diploma: 'BTS', section: 'CI', subject: 'Langue vivante étrangère', subject_code: 'BTS_CI_Langue_vivante_etrangere' },
  { diploma: 'BTS', section: 'CI', subject: 'Culture économique, juridique et managériale', subject_code: 'BTS_CI_Culture_economique_juridique_manageriale' },
  { diploma: 'BTS', section: 'CI', subject: 'Développement de la relation commerciale dans un environnement interculturel', subject_code: 'BTS_CI_Dev_relation_commerciale_interculturel' },
  { diploma: 'BTS', section: 'CI', subject: 'Mise en œuvre des opérations internationales', subject_code: 'BTS_CI_Mise_en_oeuvre_operations_internationales' },
  { diploma: 'BTS', section: 'CI', subject: 'Participation au développement commercial international', subject_code: 'BTS_CI_Participation_developpement_commercial_international' },

  // =====================
  // BTS CG
  // =====================
  { diploma: 'BTS', section: 'CG', subject: 'Culture générale et expression', subject_code: 'BTS_CG_Culture_generale_et_expression' },
  { diploma: 'BTS', section: 'CG', subject: 'Langue vivante étrangère', subject_code: 'BTS_CG_Langue_vivante_etrangere' },
  { diploma: 'BTS', section: 'CG', subject: 'Mathématiques appliquées', subject_code: 'BTS_CG_Mathematiques_appliquees' },
  { diploma: 'BTS', section: 'CG', subject: 'Culture économique, juridique et managériale', subject_code: 'BTS_CG_Culture_economique_juridique_manageriale' },
  { diploma: 'BTS', section: 'CG', subject: 'P1 - Traitement et contrôle des opérations comptables', subject_code: 'BTS_CG_Traitement_controle_operations_comptables' },
  { diploma: 'BTS', section: 'CG', subject: 'P2 - Contrôle et production de l\'information financière', subject_code: 'BTS_CG_Controle_production_information_financiere' },
  { diploma: 'BTS', section: 'CG', subject: 'P3 - Gestion des obligations fiscales', subject_code: 'BTS_CG_Gestion_obligations_fiscales' },
  { diploma: 'BTS', section: 'CG', subject: 'P4 - Gestion des relations sociales', subject_code: 'BTS_CG_Gestion_relations_sociales' },
  { diploma: 'BTS', section: 'CG', subject: 'P5 - Analyse et prévision de l\'activité', subject_code: 'BTS_CG_Analyse_prevision_activite' },
  { diploma: 'BTS', section: 'CG', subject: 'P6 - Analyse de la situation financière', subject_code: 'BTS_CG_Analyse_situation_financiere' },
  { diploma: 'BTS', section: 'CG', subject: 'P7 - Fiabilisation de l\'information comptable', subject_code: 'BTS_CG_Fiabilisation_information_comptable' },

  // =====================
  // BTS GPME
  // =====================
  { diploma: 'BTS', section: 'GPME', subject: 'Culture générale et expression', subject_code: 'BTS_GPME_Culture_generale_et_expression' },
  { diploma: 'BTS', section: 'GPME', subject: 'Langue vivante étrangère', subject_code: 'BTS_GPME_Langue_vivante_etrangere' },
  { diploma: 'BTS', section: 'GPME', subject: 'Culture économique, juridique et managériale', subject_code: 'BTS_GPME_Culture_economique_juridique_manageriale' },
  { diploma: 'BTS', section: 'GPME', subject: 'Gérer la relation avec les clients et les fournisseurs', subject_code: 'BTS_GPME_Gerer_relation_clients_fournisseurs' },
  { diploma: 'BTS', section: 'GPME', subject: 'Participer à la gestion des risques', subject_code: 'BTS_GPME_Participer_gestion_risques' },
  { diploma: 'BTS', section: 'GPME', subject: 'Gérer le personnel et contribuer à la GRH', subject_code: 'BTS_GPME_Gerer_personnel_contribuer_GRH' },
  { diploma: 'BTS', section: 'GPME', subject: 'Soutenir le fonctionnement et le développement', subject_code: 'BTS_GPME_Soutenir_fonctionnement_developpement' },
  { diploma: 'BTS', section: 'GPME', subject: 'Communication', subject_code: 'BTS_GPME_Communication' },

  // =====================
  // BTS SAM
  // =====================
  { diploma: 'BTS', section: 'SAM', subject: 'Culture générale et expression', subject_code: 'BTS_SAM_Culture_generale_et_expression' },
  { diploma: 'BTS', section: 'SAM', subject: 'Expression et culture en langues vivantes étrangères', subject_code: 'BTS_SAM_Expression_culture_langues_vivantes' },
  { diploma: 'BTS', section: 'SAM', subject: 'Culture économique, juridique et managériale', subject_code: 'BTS_SAM_Culture_economique_juridique_manageriale' },
  { diploma: 'BTS', section: 'SAM', subject: 'Optimisation des processus administratifs', subject_code: 'BTS_SAM_Optimisation_processus_administratifs' },
  { diploma: 'BTS', section: 'SAM', subject: 'Gestion de projet', subject_code: 'BTS_SAM_Gestion_projet' },
  { diploma: 'BTS', section: 'SAM', subject: 'Collaboration à la gestion des RH', subject_code: 'BTS_SAM_Collaboration_gestion_RH' },

  // =====================
  // BTS Communication
  // =====================
  { diploma: 'BTS', section: 'Communication', subject: 'Culture générale et expression', subject_code: 'BTS_Communication_Culture_generale_et_expression' },
  { diploma: 'BTS', section: 'Communication', subject: 'Langue vivante étrangère', subject_code: 'BTS_Communication_Langue_vivante_etrangere' },
  { diploma: 'BTS', section: 'Communication', subject: 'Culture économique, juridique et managériale', subject_code: 'BTS_Communication_Culture_economique_juridique_manageriale' },
  { diploma: 'BTS', section: 'Communication', subject: 'Contribution à l\'élaboration et pilotage de la stratégie de communication', subject_code: 'BTS_Communication_Contribution_elaboration_pilotage_strategie' },
  { diploma: 'BTS', section: 'Communication', subject: 'Conception et mise en œuvre de solutions de communication', subject_code: 'BTS_Communication_Conception_mise_oeuvre_solutions' },
  { diploma: 'BTS', section: 'Communication', subject: 'Accompagnement du développement de solutions médias et numériques', subject_code: 'BTS_Communication_Accompagnement_developpement_solutions_medias' },
  { diploma: 'BTS', section: 'Communication', subject: 'Cultures de la communication', subject_code: 'BTS_Communication_Cultures_de_la_communication' },
];

export type Diploma = 'BTS';

export const SECTIONS: string[] = ['MCO', 'NDRC', 'CI', 'CG', 'GPME', 'SAM', 'Communication'];

// Rétrocompatibilité pour le code existant qui utilise SECTIONS_BY_DIPLOMA
export const SECTIONS_BY_DIPLOMA: Record<Diploma, string[]> = {
  BTS: SECTIONS,
};

export const SECTION_LABELS: Record<string, string> = {
  MCO: 'Management Commercial Opérationnel',
  NDRC: 'Négociation et Digitalisation de la Relation Client',
  CI: 'Commerce International',
  CG: 'Comptabilité et Gestion',
  GPME: 'Gestion de la PME',
  SAM: 'Support à l\'Action Managériale',
  Communication: 'Communication',
};

export function getSubjectsBySection(section: string): SubjectCatalogEntry[] {
  return SUBJECTS_CATALOG.filter(
    (entry) => entry.section === section
  );
}

// Rétrocompatibilité
export function getSubjectsByDiplomaAndSection(_diploma: Diploma, section: string): SubjectCatalogEntry[] {
  return getSubjectsBySection(section);
}

export function getSubjectByCode(code: string): SubjectCatalogEntry | undefined {
  return SUBJECTS_CATALOG.find((entry) => entry.subject_code === code);
}

export function getSubjectLabelByCode(code: string): string {
  const entry = getSubjectByCode(code);
  return entry?.subject || code;
}
